import { render, staticRenderFns } from "./HeaderClassification.vue?vue&type=template&id=1785fbc8&"
import script from "./HeaderClassification.vue?vue&type=script&lang=js&"
export * from "./HeaderClassification.vue?vue&type=script&lang=js&"
import style0 from "./HeaderClassification.vue?vue&type=style&index=0&lang=scss&scoepd=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports